// Modules
import React from "react";
// @ts-ignore
import { LocalizationContext } from 'react-localize';
import moment from "moment";

// Styles
import "./OmniPresentSearchBar.sass";

// Interfaces
import Criteria from "Interfaces/CriteriaInterface";
import FormData from "Interfaces/FormDataInterface";
import Validators from "Interfaces/ValidatorsInterface";
import { ContractToolTip } from "Interfaces/ContractToolTipInterface";

// Components
import AdvancedSearch from "./AdvancedSearch";
import ResortDropdown from "Generic/ResortDropdown/ResortDropdown";
import MvSelect from "Generic/MvSelect";
import MvToggle from "Generic/MvToggle";
import MvCheckbox from "Generic/MvCheckBox";
import MvDatePicker from "Generic/MvDatePicker"
import MvSpinner from "Generic/MvSpinner";
import { Position } from "Generic/ToolTip/ToolTip";
import { logAnalyticData, trackAnalyticData } from "Utils/analytics";

type Tip = {
  label:string;
  desc:string;
};

type Options ={
  min: number;
  max: number;
}
type State = {
  datePickerValue: string
}
type Props = {
  onChange: (name: string, value: any) => void;
  onSubmit:(formData:{}) => void;
  form: FormData;
  criteria : Criteria;
  onAdvancedSearch:() => void;
  removeResorts: (propertyCode: string[]) => void;
  onClearSearch:() => void;
  isFormDefault: boolean;
  contractToolTips: ContractToolTip[];
  resortLimit? : string;
  isDateChanged :boolean;
  isLoading: boolean;
};

class OmniPresentSearchForm extends React.Component<Props, State, Tip > {

  formRequirements = {
    flexibleSearch: [],
    activity: [],
    startDate: ["required"],
    numNights: ["required", "max", "min", { max: 21, min: 1 }],
    accessibility: [],
    resorts: ["required"],
    numGuests: ["required", "max", "min", { max: 21, min: 1 }],
    hearing: []
  };

  flexSearchTip: [Tip]= [
    {
      label: "",
      desc: "static.content.tip.flex-search"
    }
  ];
  accessTip :any= [
    {
      label: "static.content.tip.label.access-tub",
      desc: "static.content.tip.access-tub"
    },
    {
      label: "static.content.tip.label.access-roll-in-shower",
      desc: "static.content.tip.access-roll-in-shower"
    },
    {
      label: "static.content.tip.label.access-transfer-shower",
      desc: "static.content.tip.access-transfer-shower"
    },
    { label: "static.content.tip.label.access-hearing-accessible",
      desc: "static.content.tip.access-hearing-accessible"
    }
  ];
  guestTip : [Tip]= [
    {
      label: "",
      desc: "static.content.tip.guest"
    }
  ];

  
  constructor(props: any) {
    super(props);
    this.state = {
        datePickerValue:this.props.form.startDate
      };
    this.handleInput = this.handleInput.bind(this);
    this.onAdvancedSearch = this.onAdvancedSearch.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.getStartDate = this.getStartDate.bind(this);
    this.performActionOnSpace = this.performActionOnSpace.bind(this);
    /**
     * Setting up adobe analytics on load of PWAS Page
     * This will trigger once the PWAS search bar is loaded
     */
    logAnalyticData({ event: 'Search Resorts', siteSection: '', pageName:'Book My Holiday', website:'' }, {
      ownerActivity: 'Points Reservation',
      step:'1:Search Results',
      errorMessagfe:"",
      notificationType: ""
    })
    trackAnalyticData('points:omnipresent');
  }

  validators = {
    required: this.required,
    max: this.max,
    min: this.min
  };

  handleInput(e: any): void {
  const target = e.target;
  let value;
  let name = target.name;

  if (target.type === "checkbox") {
    value = target.checked;
  } else if (target.attributes && target.attributes.role && target.attributes.role.value === "checkbox") {
    name = target.dataset.name;
    value = !this.props.form[name];
  } else {
    value = target.value;
  }

  this.props.onChange(name, value);

  // Handle special case for startDate when flexibleSearch is toggled
  if (name === 'flexibleSearch' && typeof value === "boolean" && !value) {
    // Reset the startDate to an empty string when flexibleSearch is toggled off
    this.setState({ datePickerValue: this.props.form.startDate}, ()=>{
      this.props.onChange("startDate", this.state.datePickerValue);
      this.forceUpdate();
    });
    
  }
}

  getStartDate() {
    let date = this.props.form["startDate"];
    if (date === "") {
      date = moment().format("MM/DD/YYYY")
    }
    return date
  }

  onSubmit(formData = {}) :void {
    if (this.props.onSubmit) {
      this.props.onSubmit(formData);
    }
  }

  required(value:any) {
    if (value.constructor === Object) {
      return Object.entries(value).length !== 0;
    } else if (value.constructor === Array) {
      return value[0] ? true : false;
    }
    return value ? true : false;
  }

  min(value:Object, options:any):boolean {
    return value >= options["min"];
  }

  max(value:Object, options:Options):boolean {
    return value <= options["max"];
  }

  validate(formValidation:any, currentForm:any) {
    return Object.keys(formValidation).filter(field => {
      let currentVal = currentForm[field];
      let validators = formValidation[field];
      let options =
        typeof validators[validators.length - 1] === "object"
          ? validators[validators.length - 1]
          : {};
      return !validators
        .map((val: Validators) => {
          if (typeof val === "string") {
            let func: Validators["func"] = this.validators[val];
            if(typeof func === "function")
            return func(currentVal, options);
          }
          return true;
        })
        .every((val: boolean) => {
          return true === val;
        });
    });
  }


  resortDisplay(value: number, limit: number, max:string, of:string, msg:string, add: string) :string {
    if (value === 0) {
      return "";
    } if (value >= 1 && value < limit) {
      return `${value} ${msg}, ${add}`;
    } else {
      return `${max} ${of} ${value} ${msg}`;
    }
  }

  onAdvancedSearch() {
    this.props.onAdvancedSearch();
  }

  performActionOnSpace(event: React.KeyboardEvent<HTMLElement>, action:any) {
    if (event.keyCode == 32) {
      event.preventDefault()
      action()
    }
  }

  componentDidUpdate(prevProps: Props): void {
   if (prevProps.isDateChanged !== this.props.isDateChanged) {
      this.setState({ datePickerValue: this.props.form.startDate });
      this.props.onChange("startDate", this.props.form.startDate);
  }
    
  }
render() {
    const { localize } = this.context;
    let dateSearch;
    let datePickerValue: any = this.state.datePickerValue || this.props.form["datePicker"];
    const today = moment();
    const todayFormatted = today.format('MM/DD/YYYY');
    const firstDateOfCurrentMonth = today.startOf('month').format('MM/DD/YYYY');

    // Determine the first date of the month based on the current date or start date
    let firstDateOfMonth;
    if (this.props.form.startDate) {
        const startDate = moment(this.props.form.startDate);
        if (startDate.isSame(today, 'month')) {
            firstDateOfMonth = todayFormatted;
        } else {
            firstDateOfMonth = startDate.startOf('month').format('MM/DD/YYYY');
        }
    } else {
        firstDateOfMonth = firstDateOfCurrentMonth;
    }
    // Check if the firstDateOfMonth is in the searchMonths list
    const searchMonths = this.props.criteria.searchMonths.map(month => month.value);
    const validFirstDate = searchMonths.includes(firstDateOfMonth) ? firstDateOfMonth : this.props.form.startDate;
    if (this.props.form["flexibleSearch"]) {
      dateSearch = (
        <MvSelect
          name="startDate"
          onChange={this.handleInput}
          label={localize('static.content.search-month')}
          required={true}
          value={validFirstDate}
          items={this.props.criteria.searchMonths}
          tabIndex={2}
        />
      );
    } else {

      dateSearch = (
        <MvDatePicker
          id="exact-date"
          name="startDate"
          required={true}
          tabIndex={2}
          softError={localize('static.content.outside-booking-window')}
          items={this.props.criteria.searchMonths}
          placeholder={localize('static.content.search-by-date')}
          onChange={this.handleInput}
          value={datePickerValue}
          isDateChanged = {this.props.isDateChanged}
          nextAvailableDate = {this.props.form["startDate"]}
        />
      )
    }

    //TODO: What is wrong with this?
    let resortData:any[] = this.props.criteria["resorts"];

    let hasAnyContractSelected = this.props.form.contracts.length > 0

    let validForm = !(
      this.validate(this.formRequirements, this.props.form).length === 0
    ) || !this.props.criteria.enableOwnerSearchAvailability;

    let nightsDisabled = !this.props.form["startDate"];
    let numberOfResortsSelected = Object.keys(this.props.form["resorts"]).length;
    //fixing according to BIM-404
    let flexibleSearchLbl = localize('static.content.flexible-search') + " ";
    flexibleSearchLbl = flexibleSearchLbl + (this.props.form["flexibleSearch"] ? localize('static.content.on') : localize('static.content.off'));
    const restrictReservationFromWebServices = !(this.props.criteria.contracts.length == 0 || this.props.criteria.contracts.some(x => x.contracts.some(y => !y.restrictReservationFromWebServices)))

    const resortLimit: number = process.env.REACT_APP_MODE === 'VOA' ? 
                                isNaN(localize('static.content.resort-limit-text')) ? Number(process.env.REACT_APP_RESORT_LIMIT) || 15 : Number(localize('static.content.resort-limit-text'))
                                : isNaN(localize('static.content.resort-limit-text')) ? Number(this.props.resortLimit || "10") : Number(localize('static.content.resort-limit-text'));

    if (restrictReservationFromWebServices) {
      return <div><h2>{localize('static.content.pwas-owner')}</h2></div>
    }



    return (
      <form className="opsb">
        <div className={this.props.form.advancedSearch ? "opsb-wrapper pb" : "opsb-wrapper"}>
          <div className="search-form">
            <div className="row header">
              <h2>{localize('static.content.search')}</h2>
              <div className="thirty toggle-wrapper">
                <MvToggle
                  toolTip={this.flexSearchTip}
                  name="flexibleSearch"
                  label={flexibleSearchLbl}
                  ariaLabel="Toggle between Flexible Search or Exact Search"
                  checked={this.props.form["flexibleSearch"]}
                  onChange={this.handleInput}
                  tabIndex={2}
                />
              </div>
            </div>

            <div className="row">
              <div className="thirty-two column">
                <div className="single-input">
                  <MvSelect
                    name="activity"
                    label={localize('static.content.activity')}
                    onChange={this.handleInput}
                    items={this.props.criteria["activities"]}
                    value={this.props.form["activity"]}
                    tabIndex={2}
                  />
                </div>
                <div id="resort-dd-single-input" className="single-input">
                  <ResortDropdown
                    name="resorts"
                    limit={resortLimit}
                    activityFilter={this.props.form["activity"]}
                    selected={this.props.form["resorts"]}
                    value={this.resortDisplay(
                        numberOfResortsSelected,
                        resortLimit,
                        localize('static.content.max'),
                        localize('static.content.of'),
                        localize('static.content.num-resorts-selected'),
                        localize('static.content.click-to-add')
                      )
                    }
                    onRemove={this.props.removeResorts}
                    required={true}
                    onChange={this.handleInput}
                    resortData={resortData}
                    tabIndex={3}
                  />
                </div>
              </div>

              <div className="thirty column">
                <div className="desktop-hide">
                  <MvToggle
                    id="flexibleSearchToggle"
                    toolTip={this.flexSearchTip}
                    name="flexibleSearch"
                    label="Flexible Search On"
                    checked={this.props.form["flexibleSearch"]}
                    onChange={this.handleInput}
                  />
                </div>
                <div className="mobile-row">
                  <div id="select-nights" className="months-and-nights">
                    {dateSearch}
                  </div>
                  <div id="nights-number" className="months-and-nights">
                    <MvSpinner
                      min={1}
                      max={21}
                      isMobile={(navigator.userAgent.indexOf("Mobi")) > -1}
                      disabled={nightsDisabled}
                      onChange={this.handleInput}
                      required={true}
                      softError={localize('static.content.warning.max-num-of-nights')}
                      hardError={localize('static.content.warning.max-num-of-nights')}
                      name="numNights"
                      value={this.props.form["numNights"]}
                      placeholder={localize('static.content.num-of-nights')}
                      label={localize('static.content.num-of-nights')}
                      tabIndex={2}
                      getText={(num) => {
                        return `${num} ${num === 1 ? localize('static.content.night') : localize('static.content.nights')}`;
                      }}
                    />
                  </div>
                  <div id="guest-number" className="single-input">
                    <MvSpinner
                      max={9}
                      min={1}
                      onChange={this.handleInput}
                      hardError={localize('static.content.warning.max-num-of-guests')}
                      softError={localize('static.content.warning.max-num-of-guests')}
                      disabled={false}
                      name="numGuests"
                      isMobile={(navigator.userAgent.indexOf("Mobi")) > -1}
                      required={true}
                      value={this.props.form["numGuests"]}
                      placeholder={localize('static.content.num-of-guests')}
                      toolTip={this.guestTip}
                      toolTipPosition={Position.LEFT}
                      tabIndex={4}
                      label={localize('static.content.num-of-guests')}
                      getText={(num) => {
                        return `${num === 9 ? '9+' : num} ${num === 1 ? localize('static.content.guest') : localize('static.content.guests')}`;
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="thirty column">
                <div className="single-input">
                  <MvSelect
                    name="accessibility"
                    label={localize('static.content.accessibility')}
                    onChange={this.handleInput}
                    items={this.props.criteria["accessibility"]}
                    toolTip={this.accessTip}
                    toolTipPosition={Position.LEFT}
                    value={this.props.form["accessibility"]}
                    tabIndex={2}
                  />
                  <div className="hearing-access-check">
                    <MvCheckbox
                      label={localize('static.content.hearing-accessible')}
                      checked={this.props.form["hearing"]}
                      name="hearing"
                      id="hearing-cb"
                      onChange={this.handleInput}
                      tabIndex={2}
                    />
                  </div>
                </div>

                <div className={this.props.form.advancedSearch ? "as-expanded single-input form-button-footer" : "single-input form-button-footer"}>
                  <div className="opsb-top">
                    <a
                      role="button"
                      className={`form-action-link start-over ${this.props.isFormDefault ? 'disabled' : ''}`}
                      tabIndex={5}
                      onClick={() => {
                        if (!this.props.isFormDefault) {
                          this.props.onClearSearch();
                        }
                      }}
                      onKeyDown={(event) => this.performActionOnSpace(event, this.props.onClearSearch)}
                    >
                      {localize('static.content.start-over')}
                    </a>
                    <button className={(validForm || !hasAnyContractSelected) ? "form-action-button mv-button primary disabled" : "form-action-button mv-button primary"} tabIndex={7} disabled={validForm || !hasAnyContractSelected || this.props.isLoading} type="button" onClick={() => {this.onSubmit()}}>
                      <span className="search-carat">{this.props.isLoading ? localize('static.content.please-wait') : localize('static.content.search')}</span> 
                    </button>
                  </div>

                  <div className="search-buttons">
                    <a role="button" onClick={this.onAdvancedSearch} className="form-action-line" tabIndex={5} onKeyDown={(event) => this.performActionOnSpace(event, this.onAdvancedSearch)}>
                      {!this.props.form.advancedSearch ? localize('static.content.advanced-search') : localize('static.content.close-advanced-search')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <AdvancedSearch
              show={this.props.form.advancedSearch}
              selected={this.props.form.contracts}
              contracts={this.props.criteria.contracts}
              onChange={this.handleInput}
              onClearSearch={this.props.onClearSearch}
              validForm={validForm}
              onSubmit={this.props.onSubmit}
              onAdvancedSearch={this.onAdvancedSearch}
              form={this.props.form}
              localize={localize}
              enableOwnerSearchAvailability={this.props.criteria.enableOwnerSearchAvailability}
              contractToolTips={this.props.contractToolTips}
            />
          </div>
        </div>
      </form>
    );
  }
}

OmniPresentSearchForm.contextType = LocalizationContext;

export default OmniPresentSearchForm;
